import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ 
  children, 
  requiredPermission = null, 
  requiredPermissions = null,
  requiredSection = null, 
  requiredAction = null 
}) => {
  const { user, loading, checkPermission, hasAnyPermission } = useAuth();
  const location = useLocation();

  console.log("requiredPermission", requiredPermission);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check permissions if specified

  console.log('Have View Permission', checkPermission('View Forms and Tasks'));
  if (requiredPermission) {
    console.log('requiredPermission', requiredPermission);
    console.log('checkPermission', checkPermission(requiredPermission));
    if (!checkPermission(requiredPermission)) {
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  }

  // Check multiple permissions (any of them)
  if (requiredPermissions && requiredPermissions.length > 0) {
    if (!hasAnyPermission(requiredPermissions)) {
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  }

  // Check section and action permissions if provided
  if (requiredSection && requiredAction) {
    let hasAccess = false;
    
    switch (requiredAction) {
      case 'view':
        hasAccess = checkPermission(`View ${requiredSection}`);
        break;
      case 'create':
        hasAccess = checkPermission(`Create ${requiredSection}`);
        break;
      case 'update':
        hasAccess = checkPermission(`Update ${requiredSection}`);
        break;
      case 'delete':
        hasAccess = checkPermission(`Delete ${requiredSection}`);
        break;
      default:
        hasAccess = checkPermission(`View ${requiredSection}`);
    }

    if (!hasAccess) {
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  }

  // Check view permission for section if only section is provided
  if (requiredSection && !requiredAction) {
    if (!checkPermission(`View ${requiredSection}`)) {
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  }

  return children;
};

export default PrivateRoute; 